export default "__VITE_ASSET__Dx1KuT3X__"